/* eslint-disable max-len */
import React, { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import { LanguageContext } from '../../../libs/Context';
import { toast } from 'react-toastify';
import { useDropzone } from 'react-dropzone';

const MDSelectFiles = (props) =>
{
	const { closePopUP, onDrop } = props;
	const { language } = useContext(LanguageContext);

	const onDropRejected = (fileRejections) =>
	{
		if (fileRejections.length > 0)
		{
			toast.error(language?.oopsImgTypeIncrt, {
				position  : toast.POSITION.TOP_RIGHT,
				autoClose : 2000
			});
		}
	};

	const acceptType = {
		maxSize : 1 * 1024 * 1024 * 1024, // 1 GB
		accept  : {
			'image/*'       : [ '.png', '.gif', '.jpeg', '.jpg', '.webp', 'heic', 'heif' ],
			'video/*'       : [ '.mp4', '.avi', '.flv', '.webm' ],
			'audio/*'       : [ '.mp3', '.wav', '.ogg', '.aac', '.flac', '.m4a', '.wma' ],
			'application/*' : [ '.doc', '.docx', '.pdf', '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.rtf' ]
		},
		onDrop,
		onDropRejected
	};

	const { getRootProps, getInputProps } = useDropzone({
		...acceptType,
		noClick    : true,
		noKeyboard : true,
		onDrop,
		onDropRejected
	});

	return (
		<Dialog open fullWidth maxWidth='sm'>
			<DialogTitle>
				<div className='flexRow brdrBSM alignCntr pdngSM'>
					<div className='flexMinWidthRow'>{language.uploadFiles}</div>
					<button className='flexAutoRow pointer' onClick={closePopUP}>
						<Tooltip title={language.close}>
							<CloseIcon />
						</Tooltip>
					</button>
				</div>
			</DialogTitle>
			<DialogContent sx={{ minHeight: '250px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<div {...getRootProps()} className='flexCol fullHeight alignCntr justifyCntr dropzone'>
					<input {...getInputProps()} // Pass onChange handler to getInputProps
						accept='.doc, .webp, .docx, .pdf, .xls, .xlsx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .ppt, .pptx, video/mp4, video/x-m4v, video/*, image/x-png, image/gif, image/jpeg, image/jpg, image/png, image/webp, image/*, .mp3, .wav, .ogg, .aac, .flac, .m4a, .wma, audio/mpeg, audio/wav, audio/ogg, audio/aac, audio/flac, audio/mp4, audio/x-ms-wma'
						className='uploadInput'
						id='filesType'
						type='file'
						value=''
						title={language?.uploadFiles}
						multiple
						style={{ display: 'none' }}
					/>
					<Button variant='outlined' className='capitalTxt subHeadingXXS' component='label' htmlFor='filesType'>{language.browseFiles}</Button>
					<span className='pdngVXS'>{language?.or}</span>
					<span className='subHeadingXXS grayTxt'>{language.DragDropFilesHere}</span>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default MDSelectFiles;
